<template>
  <div class="editor">
    <div id="e">
    </div>
  </div>
</template>

<script>
  import E from "wangeditor"
  import baseUrl from '@/api/baseUrl.js' 
  export default {
    name: 'editor',
    data() {
      return {
        content: "",
        editor: null,
        info_: null
      }
    },
    model: {
      prop: 'desc',
      event: 'change'
    },
    watch: {
      isClear(val) {
        // console.log(val)
        if (val) {
          this.editor.txt.clear()
          // this.info_=null
        }
      },
      desc(value) {
        if(this.editor.txt.text().length > this.maxLength){
          this.$emit('error')  
        }else{
          this.$emit('right')  
        } 

        if (value != this.editor.txt.html()) {
          this.editor.txt.html(this.desc)
        }
      }
    },
    props: {
      desc: {
        type: String,
        default: ""
      },
      //业务中我们经常会有添加操作和编辑操作，添加操作时，我们需清除上一操作留下的缓存
      isClear: {
        type: Boolean,
        default: false
      },
      maxLength: {
        type: Number,
        default: 50000000
      }
    },

    methods: {
      initE() {
       
         


        this.editor = new E('#e')
        // console.log('this.editorthis.editor', this.editor)
        this.editor.config.onchangeTimeout = 1000 // 单位 ms
        this.editor.config.uploadImgShowBase64 = true
        this.editor.config.height = 500
        this.editor.config.uploadFileName = 'file'
        this.editor.config.uploadImgServer = baseUrl.newucUrl + "/tjfae-space/space/lecture/file/upload" // 你的服务器地址
        this.editor.config.uploadVideoServer = baseUrl.newucUrl + "/tjfae-space/space/lecture/file/upload" 
        this.editor.config.uploadVideoName = 'file'
        
       

        this.editor.config.uploadImgHooks = {
          before: function(xhr, editor, files) {
            console.log(11,xhr)
            // 图片上传之前触发
            // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，files 是选择的图片文件

            // 如果返回的结果是 {prevent: true, msg: 'xxxx'} 则表示用户放弃上传
            // return {
            //     prevent: true,
            //     msg: '放弃上传'
            // }
          },
          success: function(xhr, editor, result) { 

            // 图片上传并返回结果，图片插入成功之后触发
            // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
          },
          fail: function(xhr, editor, result) {
            // 图片上传并返回结果，但图片插入错误时触发
            // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象，result 是服务器端返回的结果
          },
          error: function(xhr, editor) {
            // 图片上传出错时触发
            // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
          },
          timeout: function(xhr, editor) {
            // 图片上传超时时触发
            // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
          },

          // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
          // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
          customInsert: function(insertImg, result, editor) {
            // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
            // insertImg 是插入图片的函数，editor 是编辑器对象，result 是服务器端返回的结果

            // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
            console.log(222,result.data)
            var url = result.data.path
            insertImg(url)

            // result 必须是一个 JSON 格式字符串！！！否则报错
          }
        }
        this.editor.config.onchange = (html) => {

          this.info_ = html // 绑定当前逐渐地值
          this.$emit('change', this.info_) // 将内容同步到父组件中
          
        }
        this.editor.config.menus = [
          'head',
          'bold',
          'fontSize',
          'fontName',
          'italic',
          'underline',
          'strikeThrough',
          'indent',
          'lineHeight',
          'foreColor',
          'backColor',
          'link',
          'list',
          'todo',
          'justify',
          'quote',
          'emoticon',
          'image',
          'video',
          'table',
          // 'code',
          'splitLine',
          'undo',
          'redo',
        ]


         //上传视频的回调
      this.editor.config.uploadVideoHooks = {
        // 上传视频之前
/*        before: function(xhr) {
          console.log(xhr)
          // 可阻止视频上传
          return {
            prevent: true,
            msg: '需要提示给用户的错误信息'
          }
        },*/
        // 视频上传并返回了结果，视频插入已成功
        success: function(xhr) {
          console.log('success', xhr)
        },
        // 视频上传并返回了结果，但视频插入时出错了
        fail: function(xhr, editor, resData) {
          console.log('fail', resData)
        },
        // 上传视频出错，一般为 http 请求的错误
        error: function(xhr, editor, resData) {
          console.log('error', xhr, resData)
        },
        // 上传视频超时
        timeout: function(xhr) {
          console.log('timeout')
        },
        // 视频上传并返回了结果，想要自己把视频插入到编辑器中
        // 例如服务器端返回的不是 { errno: 0, data: { url : '.....'} } 这种格式，可使用 customInsert
        customInsert: function(insertVideoFn, result) {
          // result 即服务端返回的接口
          console.log('customInsert', result)
          // insertVideoFn 可把视频插入到编辑器，传入视频 src ，执行函数即可
          //result.data 就是url的值
          insertVideoFn(result.data.path)
        }
      }









        this.editor.create()
        this.editor.txt.html(this.desc)
        // this.editor.txt.html(this.desc)
        //  this.editor.txt.html(this.desc)
      }
    },
    mounted() {
      this.initE();
    }
  }
</script>

<style scoped>

</style> 